/**
 * Hộp thoại tự đổi mật khẩu, mở từ thanh tiêu đề.
 *
 * Trước đây không có luồng nào cho việc này: điều tra viên muốn đổi mật khẩu phải
 * nhờ quản trị đặt lại hộ — nghĩa là mật khẩu mới đi qua tay người thứ ba, đúng
 * điều mà việc đổi mật khẩu đáng ra phải tránh.
 *
 * Máy chủ thu hồi mọi phiên cũ rồi cấp lại token cho chính thiết bị này
 * (`api.changePassword` lưu lại), nên đổi xong không bị đăng xuất, còn các thiết bị
 * khác thì mất phiên — đó là điểm chính của thao tác này.
 */
import * as api from '../api-client.js';
import { el, esc, toast } from './util.js';

export function openChangePasswordDialog() {
  const backdrop = el('div', 'dialog-backdrop');
  const form = el('form', 'dialog');
  form.noValidate = true;
  form.innerHTML = `
    <div class="dialog-head">
      <h3>Đổi mật khẩu</h3>
      <button class="icon-btn" type="button" data-act="close" aria-label="Đóng"><span class="ms">close</span></button>
    </div>
    <div class="dialog-body">
      <p class="hint-text">Sau khi đổi, mọi thiết bị khác đang đăng nhập bằng tài khoản này
         sẽ bị đăng xuất. Thiết bị bạn đang dùng thì không.</p>
      <div class="form-row">
        <label for="cpCurrent">Mật khẩu hiện tại</label>
        <input id="cpCurrent" name="currentPassword" type="password" autocomplete="current-password" required>
      </div>
      <div class="form-row">
        <label for="cpNew">Mật khẩu mới</label>
        <input id="cpNew" name="newPassword" type="password" autocomplete="new-password" minlength="8" required>
        <span class="hint-text">Tối thiểu 8 ký tự.</span>
      </div>
      <div class="form-row">
        <label for="cpConfirm">Nhập lại mật khẩu mới</label>
        <input id="cpConfirm" name="confirmPassword" type="password" autocomplete="new-password" required>
      </div>
    </div>
    <div class="dialog-error error-text" hidden></div>
    <div class="dialog-actions">
      <button class="btn btn-text" type="button" data-act="cancel">Huỷ</button>
      <button class="btn" type="submit"><span class="ms">key</span>Đổi mật khẩu</button>
    </div>`;

  backdrop.appendChild(form);
  document.body.appendChild(backdrop);

  const close = () => {
    backdrop.remove();
    document.removeEventListener('keydown', onKey);
  };
  const onKey = (e) => {
    if (e.key === 'Escape') close();
  };
  document.addEventListener('keydown', onKey);
  form.querySelector('[data-act="close"]').addEventListener('click', close);
  form.querySelector('[data-act="cancel"]').addEventListener('click', close);
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) close();
  });
  form.querySelector('#cpCurrent').focus();

  const errBox = form.querySelector('.dialog-error');
  const submitBtn = form.querySelector('button[type="submit"]');

  const báoLỗi = (msg) => {
    errBox.textContent = msg;
    errBox.hidden = false;
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errBox.hidden = true;

    const current = form.currentPassword.value;
    const next = form.newPassword.value;
    const confirm = form.confirmPassword.value;

    // Kiểm tại chỗ những gì máy chủ không biết: nó chỉ nhận một mật khẩu mới, nên
    // gõ lệch ở ô nhập lại là lỗi chỉ trình duyệt phát hiện được.
    if (next !== confirm) return báoLỗi('Hai ô mật khẩu mới không khớp nhau.');
    if (next.length < 8) return báoLỗi('Mật khẩu mới phải có ít nhất 8 ký tự.');
    if (next === current) return báoLỗi('Mật khẩu mới phải khác mật khẩu hiện tại.');

    submitBtn.disabled = true;
    try {
      await api.changePassword(current, next);
      toast('Đã đổi mật khẩu. Các thiết bị khác đã bị đăng xuất.');
      close();
    } catch (err) {
      báoLỗi(esc(err.message || 'Không đổi được mật khẩu.'));
    } finally {
      submitBtn.disabled = false;
    }
  });
}
